<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
			<h1 class="h3 mb-0 text-gray-800">Ramal {{ ramal.EXTENSION }} <small v-if="ramal.INTERNAL_CODE"> Código: {{
				ramal.INTERNAL_CODE }}</small></h1>

			<div>
				<strong> {{ ramal.NAME }} - {{ setor.NAME }} - {{ unidade.nome }}</strong>

				<pdfBtn type="datatable" datatable="Gravacao" :filter="string_filter + '&destino=' + ramal.EXTENSION"
					:title="'gravações do ramal ' + ramal.EXTENSION" :external="true" :data_head="data_head"
					:data_body="data_body" />
			</div>
		</div>

		<!-- DADOS DO RAMAL -->
		<div class="row">
			<div class="col-lg-3">
				<div class="form-group">
					<label>Tipo</label>
					<input type="text" class="form-control form-control-sm"
						:value="(ramal.TYPE == 'INT') ? 'Interno' : 'Externo'" readonly>
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group">
					<label>Telefone</label>
					<input type="text" class="form-control form-control-sm" :value="ramal.PHONE_NUMBER"
						v-mask="['(##) ####-####', '(##) #####-####']" readonly>
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group">
					<label>Início atividade</label>
					<input type="time" class="form-control form-control-sm" :value="ramal.START_TIME" readonly>
				</div>
			</div>

			<div class="col-lg-3">
				<div class="form-group">
					<label>Fim atividade</label>
					<input type="time" class="form-control form-control-sm" :value="ramal.END_TIME" readonly>
				</div>
			</div>
		</div>
		<!-- FIM DADOS DO RAMAL -->

		<alert :type="alert.type" :mensagem="alert.msg" />
		<filtros :filter_data="filter_data" @filtrar="filtrar" />
		<priority />

		<table class="table table-striped table-hover table-sm table-responsive-xl">
			<thead align="center">
				<th @click="orderBy('id')">ID <font-awesome-icon v-if="direction.by == 'id'" :icon="order_icon" size="xs" />
				</th>
				<th @click="orderBy('data')">DATA <font-awesome-icon v-if="direction.by == 'data'" :icon="order_icon"
						size="xs" /></th>
				<th @click="orderBy('hora')">HORA <font-awesome-icon v-if="direction.by == 'hora'" :icon="order_icon"
						size="xs" /></th>
				<th @click="orderBy('origem')">ORIGEM <font-awesome-icon v-if="direction.by == 'origem'" :icon="order_icon"
						size="xs" /></th>
				<th @click="orderBy('destino')">DESTINO <font-awesome-icon v-if="direction.by == 'destino'"
						:icon="order_icon" size="xs" /></th>
				<th>DURAÇÃO</th>
				<th @click="orderBy('prioridade')">PRIORIDADE <font-awesome-icon v-if="direction.by == 'prioridade'"
						:icon="order_icon" size="xs" /></th>
				<th @click="orderBy('status')">STATUS <font-awesome-icon v-if="direction.by == 'status'" :icon="order_icon"
						size="xs" /></th>
				<th @click="orderBy('resumo')">RESUMO <font-awesome-icon v-if="direction.by == 'resumo'" :icon="order_icon"
						size="xs" /></th>
				<th></th>
			</thead>

			<transition mode="out-in" name="leftIn">
				<tbody v-if="records" align="center">
					<tr v-for="(gravacao, index) in records.result.data" :key="index">
						<td>{{ gravacao.id }}</td>
						<td>{{ ajuste_hora(gravacao.created_at) | moment("DD/MM/YYYY") }}</td>
						<td>{{ ajuste_hora(gravacao.created_at) }}</td>
						<td>{{ Phone(gravacao.origem) }}</td>
						<td>{{ Phone(gravacao.destino) }}</td>
						<td v-if="gravacao.duration !== undefined">{{ gravacao.duration }}</td>
						<td v-else>Calculando...</td>
						<td><font-awesome-icon icon="flag" :class="priority_color(gravacao.prioridade)" /></td>
						<td>{{ get_status(gravacao.status) }}</td>
						<td> {{ gravacao.resumo }}</td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(gravacao)" /></td>
						<td v-if="is_super_adm()"><font-awesome-icon icon="paperclip" class="info pointer"
								@click="audio_down(gravacao.path)" /></td>
					</tr>

				</tbody>
				<Loading v-else />
			</transition>
		</table>

		<controls :data="constrol_data" @refresh="navigate" @alert="show_alert" />

		<modal :gravacao="modal_data" :ramal="ramal_id" @alert="show_alert" />
	</section>
</template>

<script>
import api from "@/mixins/api.js"
import replace from "@/mixins/replace.js"
import pdfBtn from "@/components/Tools/Pdf.vue"
import alert from "@/components/Tools/alert.vue"
import filtros from "@/components/Tools/Filtro.vue"
import controls from "@/components/Tools/Table_Control.vue"
import modal from "@/components/Modal/Views/Gravacao.vue"
import priority from "@/components/Tools/record_priority.vue"
import { Howl } from 'howler';
import { EventBus } from '@/event-bus.js';




export default {
	name: "Ramal",
	mixins: [api, replace],
	components: { controls, filtros, priority, pdfBtn, modal, alert },

	data: () => {
		return {
			ramal: {},
			setor: {},
			unidade: {},
			modal_data: {},
			constrol_data: {},
			records: null,

			direction: {
				order: "desc",
				by: "id"
			},

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{
					name: "id",
					label: "ID",
					type: "text",
					data_get: ""
				},
				{
					name: "created_at",
					label: "Data",
					type: "date",
					data_get: ""
				},
				{
					name: "origem",
					label: "Origem",
					type: "phone",
					data_get: ""
				},
				{
					name: "destino",
					label: "Destino",
					type: "phone",
					data_get: ""
				},
				{
					name: "resumo",
					label: "Resumo",
					type: "text",
					data_get: ""
				},
			],
			data_head: ["ID", "DATA", "HORA", "ORIGEM", "DESTINO", "PRIORIDADE", "STATUS", "RESUMO"],
			data_body: ["id", "data_at", "hora_at", "origem", "destino", "prioridade", "status", "resumo"],

			alert: {
				type: "",
				msg: ""
			}
		}
	},

	async created() {
		await this.get_ramal();
		await this.get_setor();
		//await this.get_unidade()
		//await this.get_unidades()
		await this.get_data();
	},

	computed: {
		ordenation() {
			return `order=${this.direction.order}&by=${this.direction.by}`;
		},

		order_icon() {
			return (this.direction.order == "asc") ? "arrow-up" : "arrow-down";
		},

		ramal_id() {
			return this.$attrs.get;
		}
	},

	methods: {
		async get_data() {
			this.records = null;
			this.records = await this.GET("Gravacao", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}&destino=${this.ramal.EXTENSION}`);

			for (const gravacao of this.records.result.data) {
				gravacao.duration = await this.getAudioDuration(gravacao.path);
			}

			this.constrol_data = {
				current_page: this.records.result.current_page,
				last_page: this.records.result.last_page,
				per_page: this.records.result.per_page,
				total: this.records.result.total,
			}

		},

		is_super_adm() {
			if (this.$store.state.user.type === 3) {
				return true;
			} else {
				return false;
			}

		},

		async get_ramal() {
			const response = await this.GET('Ramal', this.$route.params.get);
			this.ramal = response.result;
		},

		async get_unidades() {
			this.unidades = await this.GET("Unidade");
		},

		get_unidade_name(payload) {
			for (var i = 0; i <= this.unidades.result.length - 1; i++) {
				if (this.unidades.result[i].id == payload) {
					return this.unidades.result[i].nome;
				}
			}
		},

		async get_setor() {
			const response = await this.GET('Setor', this.ramal.PARENT_ID);
			this.setor = response.result;
		},

		async get_unidade() {
			const response = await this.GET('Unidade', this.setor.PARENT_ID);
			this.unidade = response.result;
		},

		async audio_down(payload) {
			var respota = await this.POST("Gravacao/pegaAudio", { path: payload });
			var nome_audio = payload;
			var fileURL = window.URL.createObjectURL(new Blob([respota]));
			var fileLink = document.createElement('a');
			fileLink.href = respota;
			fileLink.setAttribute('download', nome_audio);
			document.body.appendChild(fileLink);
			fileLink.click();

		},

		async getAudioDuration(payload) {
			try {

				var base64Data = await this.POST("Gravacao/pegaAudio", { path: payload });
				// Remove o prefixo "data:audio/x-wav;base64," da string base64
				const base64 = base64Data.replace(/^data:audio\/x-wav;base64,/, '');

				// Decodifica a string base64 para obter os dados binários
				const binaryData = atob(base64);

				// Converte os dados binários para um ArrayBuffer
				const arrayBuffer = new ArrayBuffer(binaryData.length);
				const view = new Uint8Array(arrayBuffer);
				for (let i = 0; i < binaryData.length; i++) {
					view[i] = binaryData.charCodeAt(i);
				}

				// Cria um contexto de áudio offline
				const AudioContext = window.AudioContext || window.webkitAudioContext;
				const audioContext = new AudioContext();

				// Decodifica o buffer de áudio
				const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

				// Obtém a duração do áudio em segundos
				const durationInSeconds = audioBuffer.duration;

				// Exibe o tempo do arquivo de áudio
				//console.log(`Duração do áudio: ${durationInSeconds} segundos`);
				const hours = Math.floor(durationInSeconds / 3600);
				const minutes = Math.floor((durationInSeconds % 3600) / 60);
				const seconds = Math.floor(durationInSeconds % 60);

				const formattedHours = hours.toString().padStart(2, '0');
				const formattedMinutes = minutes.toString().padStart(2, '0');
				const formattedSeconds = seconds.toString().padStart(2, '0');

				return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
			} catch (error) {
				console.error('Ocorreu um erro:', error);
			}
		},

		orderBy(payload) {
			if (payload == this.direction.by) {
				this.direction.order = (this.direction.order == 'desc') ? 'asc' : 'desc';
			} else {
				this.direction.by = payload;
			}

			this.get_data();
		},

		filtrar(payload) {
			this.string_filter = payload;
			this.get_data();
		},

		navigate(payload) {
			this.pagination = payload;
			this.get_data();
		},

		view(payload) {
			this.modal_data = payload;
			$("#modal-gravacao").modal();
		},

		show_alert(payload) {
			this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
			this.alert.msg = payload.result;

			$("#modal-gravacao").modal('hide');
			this.get_data();
			$("#app-alert").show();
			setTimeout(() => $("#app-alert").hide(), 3000);
		},

		ajuste_hora(tempo) {
			var horas = this.$moment(tempo);
			horas.subtract({ h: 3 });
			return horas.format("HH:mm:ss");
		},
	},

	beforeRouteLeave(to, from, next) {
		this.timestamps = false;
		EventBus.$emit('reset-unit-filter');
		next();
	},
}
</script>

<style></style>